"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = require("./");
var mobx_1 = require("mobx");
var OPEN_CHAR = '{';
var CLOSE_CHAR = '}';
var MODIFIER_SEPARATOR = ":";
/**
 * Will return a boolean indicating wether the passed variable is an object
 *
 * @export
 * @param {any} obj
 * @returns {boolean}
 */
function isObject(obj) {
    return (typeof obj === 'object' && !Array.isArray(obj));
}
exports.isObject = isObject;
/**
 * Will validate if the passed parameter is of type object and has no properties defined
 *
 * @param {{}} obj
 * @returns {boolean}
 */
function isObjectAndEmpty(obj) {
    if (!isObject(obj)) {
        return false;
    }
    for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
            return false;
        }
    }
    return JSON.stringify(obj) === JSON.stringify({});
}
exports.isObjectAndEmpty = isObjectAndEmpty;
/**
 * Will get the value specified in the string notation from the instance that is passed to it.
 *
 * @export
 * @param {(string |)} [stringNotation=null | undefined]
 * @param {({} |)} [instance=null | undefined]
 * @param {*} [defaultValue=null]
 * @returns {*}
 */
function getValueFromStringNotation(stringNotation, instance, defaultValue) {
    if (defaultValue === void 0) { defaultValue = null; }
    var value = null;
    var parameterList = getInnerParameters(stringNotation);
    if (parameterList && parameterList.length > 0) {
        var parameters = {};
        for (var _i = 0, parameterList_1 = parameterList; _i < parameterList_1.length; _i++) {
            var parameter = parameterList_1[_i];
            var parameterValue = getValueFromDotNotation(parameter, instance, defaultValue);
            if (parameterValue) {
                parameters[parameter] = parameterValue;
            }
        }
        value = stringNotation;
        for (var _a = 0, _b = Object.keys(parameters); _a < _b.length; _a++) {
            var parameter = _b[_a];
            var fullParameter = "" + OPEN_CHAR + parameter + CLOSE_CHAR;
            value = value.split(fullParameter).join(parameters[parameter]);
        }
    }
    else {
        value = getValueFromDotNotation(stringNotation, instance, defaultValue);
    }
    if (_1.isNullOrUndefined(value)) {
        value = defaultValue;
    }
    return value;
}
exports.getValueFromStringNotation = getValueFromStringNotation;
/**
 * This will get the value from the property for a complex identifier (If the source field is deeper than the base object it will traverse)
 *
 * @export
 * @param {(string |)} [sourceField=null | undefined]
 * @param {({} |)} [instance=null | undefined]
 * @param {*} [defaultValue=null]
 * @returns {*}
 */
function getValueFromDotNotation(sourceField, instance, defaultValue) {
    if (defaultValue === void 0) { defaultValue = null; }
    var currentObj = instance;
    var value = defaultValue;
    if (!_1.isNullOrUndefined(sourceField)) {
        var modifierDetails = null;
        if (sourceField.indexOf(MODIFIER_SEPARATOR) > -1) {
            modifierDetails = sourceField.split(MODIFIER_SEPARATOR);
            sourceField = modifierDetails.shift();
        }
        var sourceFieldSplit = sourceField.split('.');
        var _loop_1 = function () {
            if (!currentObj) {
                return "break";
            }
            var attr = sourceFieldSplit.shift();
            if (!_1.isNullOrUndefined(attr)) {
                if (sourceFieldSplit.length > 0) {
                    currentObj = _1.safe(function () { return currentObj[attr]; }, null);
                }
                else {
                    value = _1.safe(function () { return currentObj[attr]; }, defaultValue);
                }
            }
        };
        while (sourceFieldSplit.length > 0) {
            var state_1 = _loop_1();
            if (state_1 === "break")
                break;
        }
        if (modifierDetails) {
            value = applyModifier(value, modifierDetails);
        }
    }
    return value;
}
exports.getValueFromDotNotation = getValueFromDotNotation;
/**
 * Will take in the original value and details on how to modify it. This allows for uppercase, lowercase etc
 *
 * @export
 * @param {*} value
 * @param {string[]} [modifierDetails=[]]
 * @returns {*}
 */
function applyModifier(value, modifierDetails) {
    if (modifierDetails === void 0) { modifierDetails = []; }
    if (modifierDetails && modifierDetails.length > 0 && !_1.isNullOrUndefined(value) && typeof value !== "object") {
        var firstModifier = modifierDetails[0];
        // Upper case
        if (firstModifier === 'U') {
            value = value.toString().toUpperCase();
        }
        if (firstModifier === 'L') {
            value = value.toString().toLowerCase();
        }
    }
    return value;
}
exports.applyModifier = applyModifier;
/**
 * Fetches parameters that are inside the string that are wrapped with the opening and closing tags ({})
 *
 * @export
 * @param {string} stringNotation
 * @returns {string[]}
 */
function getInnerParameters(stringNotation) {
    var result = [];
    var workingNotation = stringNotation;
    var isOpen = false;
    var currentParameter = '';
    for (var _i = 0, _a = workingNotation.split(''); _i < _a.length; _i++) {
        var char = _a[_i];
        if (char === OPEN_CHAR) {
            if (!isOpen) {
                currentParameter = '';
                isOpen = true;
            }
            else {
                throw new Error('object: getInnerParameters: Nested parameters not supported in string notation');
            }
        }
        else if (char === CLOSE_CHAR) {
            if (isOpen) {
                isOpen = false;
                result.push(currentParameter);
                currentParameter = "";
            }
            else {
                throw new Error('object: getInnerParameters: No opening tag found for parameter');
            }
        }
        else if (isOpen) {
            currentParameter += char;
        }
    }
    if (isOpen) {
        throw new Error("object: getInnerParameters: No closing tag found for parameter (" + currentParameter + ")");
    }
    return result;
}
exports.getInnerParameters = getInnerParameters;
/**
 * Will return a boolean indicating wether the left object equals the right object
 *
 * @export
 * @param {{}} leftObject
 * @param {{}} rightObject
 * @returns {boolean}
 */
function isEqualObjects(leftObject, rightObject) {
    var leftProps = Object.keys(leftObject);
    var left = {
        "properties": leftProps,
        "length": leftProps.length
    };
    var rightProps = Object.keys(rightObject);
    var right = {
        "properties": rightProps,
        "length": rightProps.length
    };
    if (left.length !== right.length) {
        return false;
    }
    var index = left.length;
    while (index--) {
        var property = left.properties[index];
        if (right.properties.indexOf(property) === -1) {
            return false;
        }
        if (!_1.isEqual(leftObject[property], rightObject[property])) {
            return false;
        }
    }
    return true;
    // return JSON.stringify(leftObject) === JSON.stringify(rightObject)
}
exports.isEqualObjects = isEqualObjects;
/**
 * Will return a merged object based on the parameters passed through
 *
 * @export
 * @param {any[]} elements
 * @returns {any}
 */
function copyIsObject(a) {
    return (!!a) && (a.constructor === Object) && !mobx_1.isObservableArray(a);
}
function deepcopy(instance) {
    if (Array.isArray(instance) || mobx_1.isObservableArray(instance)) {
        return instance.map(function (item) { return deepcopy(item); });
    }
    if (copyIsObject(instance)) {
        var response = {};
        for (var _i = 0, _a = Object.keys(instance); _i < _a.length; _i++) {
            var key = _a[_i];
            response[key] = deepcopy(instance[key]);
        }
        return response;
    }
    return instance;
}
function mergeRecursive(isDeep, obj1, obj2) {
    var keys = Object.keys(obj2);
    var keysLength = keys.length;
    for (var i = 0; i < keysLength; i++) {
        var key = keys[i];
        try {
            // Property in destination object set; update its value.
            if (Array.isArray(obj2[key]) || mobx_1.isObservableArray(obj2[key])) {
                if (isDeep) {
                    obj1[key] = obj2[key].map(function (item) { return deepcopy(item); });
                }
                else {
                    obj1[key] = obj2[key];
                }
            }
            else if (copyIsObject(obj2[key])) {
                obj1[key] = mergeRecursive(isDeep, obj1[key] || {}, obj2[key]);
            }
            else {
                obj1[key] = obj2[key];
            }
        }
        catch (e) {
            // Property in destination object not set; create it and set its value.
            obj1[key] = obj2[key];
        }
    }
    return obj1;
}
function deepMergeObjects() {
    var elements = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        elements[_i] = arguments[_i];
    }
    elements = elements.filter(function (e) { return e; });
    if (elements.length < 1) {
        console.warn('Need more than 1 elements to merge');
        return;
    }
    var workingElement = {};
    var elementLength = elements.length;
    for (var i = 0; i < elementLength; i++) {
        var element = elements[i];
        if (element && Object.keys(element).length > 0) {
            workingElement = mergeRecursive(true, workingElement, element);
        }
    }
    return workingElement;
}
exports.deepMergeObjects = deepMergeObjects;
function shallowMergeObjects() {
    var elements = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        elements[_i] = arguments[_i];
    }
    elements = elements.filter(function (e) { return e; });
    if (elements.length < 1) {
        console.warn('Need more than 1 elements to merge');
        return;
    }
    var workingElement = elements[0];
    var elementLength = elements.length;
    for (var i = 1; i < elementLength; i++) {
        var element = elements[i];
        if (element && Object.keys(element).length > 0) {
            workingElement = mergeRecursive(false, workingElement, element);
        }
    }
    return workingElement;
}
exports.shallowMergeObjects = shallowMergeObjects;
function reduceToObject(collection, getKeyFn) {
    if (!getKeyFn) {
        getKeyFn = function (item) { return item.toString(); };
    }
    var response = (collection || []).reduce(function (acc, item) {
        var key = getKeyFn(item);
        acc[key] = item;
        return acc;
    }, {});
    return response;
}
exports.reduceToObject = reduceToObject;
//# sourceMappingURL=object.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys_utils/dist/object.js
// module id = 1082
// module chunks = 1